import React from "react";
import styled from "styled-components";
import CheckCircle from "@untitled-ui/icons-react/build/esm/CheckCircle";
import AlertTriangle from "@untitled-ui/icons-react/build/esm/AlertTriangle";
import PremiumDialog from "./PremiumDialog";
import PremiumHeaderButton from "./PremiumHeaderButton";
import { premiumTheme as theme } from "./premiumTheme";

// #region SCOPED CSS
const Heading = styled.span`
    color: ${theme.mandatory}; font-size: 12px; font-weight: 500; letter-spacing: 0.6px;
`;
const Content = styled.div`
    display: flex; flex-direction: column; align-items: center; gap: 16px; min-width: 0;
    color: #d1d1d1; text-align: center; font-family: ${theme.fontFamily};
    .premium-status-icon { display: flex; justify-content: center; align-items: center; color: ${theme.mandatory}; margin: 4px 0; }
    .premium-status-icon svg path { stroke-width: 1.5; }
    .premium-status-title { margin: 0; color: #fff4e3; font-size: 18px; line-height: 24px; font-weight: 600; overflow-wrap: anywhere; }
    .premium-status-message { width: 100%; min-width: 0; display: flex; flex-direction: column; gap: 12px; font-size: 14px; line-height: 21px; overflow-wrap: anywhere; }
    .premium-status-message p { margin: 0; }
    .premium-status-message [role="status"] { color: ${theme.mandatory}; font-size: 12px; line-height: 18px; }
    .premium-status-actions { display: flex; justify-content: center; width: 100%; padding-top: 4px; }
`;
const CloseButton = styled(PremiumHeaderButton)`
    && { width: 240px; max-width: 100%; min-width: 0; color: ${theme.mandatory};
        border: 1px solid ${theme.mandatory}; background: ${theme.actionBackground}; }
    &&:enabled:hover { color: ${theme.mandatory}; border-color: ${theme.mandatory};
        background: linear-gradient(180deg, #302c25, #211f1b); }
    &&:focus-visible { outline: 2px solid ${theme.mandatory}; outline-offset: 3px; }
`;
// #endregion

/** New additive status variant composed from the genuine premium primitives.
 * Presentation only: callers supply the acknowledged outcome/content and close action.
 * This is not a port of a pre-existing Staging status component.
 */
export default function PremiumStatusDialog({ variant = "warning", title, accessibleName, onClose, children }) {
    const success = variant === "success";
    const Icon = success ? CheckCircle : AlertTriangle;
    return <PremiumDialog compact premiumOverlay accessibleName={accessibleName || (success ? "Success" : "Attention")}
        title={<Heading>{success ? "SUCCESS!" : "ATTENTION!"}</Heading>} onClose={onClose}>
        <Content data-premium-status={success ? "success" : "warning"}>
            <div className="premium-status-icon" role="img" aria-label={success ? "Success" : "Warning"}>
                <Icon width={56} height={56} aria-hidden="true" />
            </div>
            <h3 className="premium-status-title">{title}</h3>
            <div className="premium-status-message">{children}</div>
            <div className="premium-status-actions"><CloseButton label="CLOSE" onClick={onClose} /></div>
        </Content>
    </PremiumDialog>;
}
